import {
  Flex,
  Progress,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Tooltip } from "antd";
import useMinhasFormaPagamentos from "core/features/forma-pagamento/hooks/useMinhasFormaPagamentos";
import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import CardDefault from "ui/components/Cards/CardDefault";
import MethodItem from "./MethodItem";
import FeedbackPagamentoOnline from "ui/components/FeedbackPagamentoOnline";

export default function MetodosCobranca({
  tenant,
  noPadding,
}: {
  tenant: TenantDetalhe;
  noPadding?: boolean;
}) {
  const { isLoading, data } = useMinhasFormaPagamentos(tenant.id);

  return (
    <CardDefault p={noPadding ? 0 : "24px"}>
      {isLoading ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          my={4}
          colorScheme="cyan"
        />
      ) : null}

      <Text mb={4} fontSize="18px" fontWeight="bold">
        Métodos de Cobrança
      </Text>

      <FeedbackPagamentoOnline tenantId={tenant.id} />

      <Table
        variant="unstyled"
        sx={{ "border-collapse": "separate", "border-spacing": "0 16px" }}
      >
        <Thead>
          <Tr>
            <Th />
            {tenant.integradoPagamentoOnline ? (
              <Th w="150px" textTransform="capitalize" fontWeight="normal">
                Taxa Padrão
              </Th>
            ) : null}
            {tenant.integradoPagamentoOnline ? (
              <Th textTransform="capitalize" fontWeight="normal">
                <Flex alignItems="center">
                  <Flex mr="6px">Taxa Extra (opcional)</Flex>
                  <Tooltip title="Essa taxa é aplicada adicionando sobre a taxa padrão do meio de pagamento">
                    <AiOutlineQuestionCircle cursor={"pointer"} />
                  </Tooltip>
                </Flex>
              </Th>
            ) : null}
            {tenant.integradoPagamentoOnline ? (
              <Th w="120px" textTransform="capitalize" fontWeight="normal">
                Taxa Total
              </Th>
            ) : null}
            <Th w="130px" textTransform="capitalize" fontWeight="normal">
              Habilitado
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.map((item, index) => (
            <MethodItem
              disableEditTax={!tenant.integradoPagamentoOnline}
              item={item}
              tenantId={tenant.id}
              key={index}
            />
          ))}
        </Tbody>
      </Table>
    </CardDefault>
  );
}
